import {
  acceptRequest,
  addRequest,
  deleteRequest,
  parseRequestDoc,
  rejectRequest,
} from '@db/Requests/Common';
import { getCurrentUserId } from '@helpers/firebase/Auth';
import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { RequestStatus, RequestType } from '@types';

export async function addJoinGroupRequest(groupId: string) {
  const currentUserId = getCurrentUserId();
  return await addRequest({
    userId: currentUserId,
    entityId: groupId,
    type: RequestType.JOIN_GROUP,
  });
}

export async function acceptJoinGroupRequest(groupId: string, userId: string) {
  return await acceptRequest({
    userId,
    entityId: groupId,
    type: RequestType.JOIN_GROUP,
  });
}

export async function rejectJoinGroupRequest(groupId: string, userId: string) {
  return await rejectRequest({
    userId,
    entityId: groupId,
    type: RequestType.JOIN_GROUP,
  });
}

export async function deleteJoinGroupRequest(groupId: string, userId: string) {
  return await deleteRequest({
    userId,
    entityId: groupId,
    type: RequestType.JOIN_GROUP,
  });
}

export function listenToPendingJoinGroupRequestGroupIds(
  onSnapshot: (groupIds: Set<string>) => void,
  onError: (error: db.FirestoreError) => void
) {
  const currentUserId = getCurrentUserId();
  const query = db.query(
    db.collection(firestore, 'requests'),
    db.where('userId', '==', currentUserId),
    db.where('type', '==', RequestType.JOIN_GROUP),
    db.where('status', '==', RequestStatus.PENDING)
  );

  return db.onSnapshot(
    query,
    (snapshot) => {
      const entityIds = snapshot.docs.map((doc) => parseRequestDoc(doc).entityId);
      onSnapshot(new Set(entityIds));
    },
    onError
  );
}

export async function getPendingJoinGroupRequestUserIds(groupId: string) {
  const query = db.query(
    db.collection(firestore, 'requests'),
    db.where('entityId', '==', groupId),
    db.where('type', '==', RequestType.JOIN_GROUP),
    db.where('status', '==', RequestStatus.PENDING)
  );

  const snap = await db.getDocs(query);
  return snap.docs.map((doc) => parseRequestDoc(doc).userId);
}
